export default "__VITE_ASSET__4fc5341c__"